import { Button } from "antd";
import CloseIcon from "../../../../assets/icons/CloseIcon";
import SuccessCheck from "../../../../assets/icons/SuccessCheck";
import CustomModal from "../../../../components/ui/CustomModal";
import { ModalComponentProps } from "../../../../types";

export default function InviteSuccessModal({
  handleClose,
  ...rest
}: ModalComponentProps) {
  return (
    <CustomModal
      {...rest}
      title=""
      closeIcon={null}
      handleClose={handleClose}
      width={460}
      footer={null}
    >
      <div className="flex justify-end">
        <Button
          className="normal-button !border-none"
          icon={<CloseIcon />}
          onClick={handleClose}
        />
      </div>

      <div className="p-1.5 flex justify-center mb-3">
        <SuccessCheck width={60} height={60} />
      </div>
      <div className="text-center mb-6 md:px-4">
        <h4 className="text-header text-[22px] font-semibold mb-2">
          Invitation sent successfully
        </h4>
        <p className="text-body-text text-base font-normal">
          Co-worker will get invitation to get access to DigiGO. Both co-worker
          or you can complete the co-worker profile from details.
        </p>
      </div>

      <div className="w-full flex justify-center">
        <Button
          className="normal-dark-button modal-button"
          onClick={handleClose}
          size="middle"
        >
          Close
        </Button>
      </div>
    </CustomModal>
  );
}
